export default import.meta.ROLLUP_FILE_URL_RuIHaY49vlqFL0cAh$dtOw